<div class="w-full h-full flex flex-col items-center justify-center gap-2 p-4">
  <span class="font-bold flex items-baseline relative" 
    [class.text-common-white]="!dark() && !fontColor()" 
    [class.text-heading-primary]="dark() && !fontColor()" 
    [class]="fontSize() + ' ' + fontColor()"
  >
    @if( computedValue() ) {
      <div class="flex items-baseline">
        @if(prefix()) {
          <span>{{ prefix() }}</span>
        }
        @for( item of computedValue(); track $index) {
          @if(item.isDigit) {
            <!-- Digit Reel -->
            <div class="relative overflow-hidden h-[1em] w-[0.6em] inline-flex flex-col items-center">
               <!-- The Strip -->
               <div class="reel flex flex-col transition-transform ease-out"
                    [class.animate-up]="item.isLastDigit && start()"
                    [class.animate-down]="!item.isLastDigit && start()"
                    [style.transform]="!start() ? 'translateY(0)' : null"
                    [style.--target]="item.value"
                    [style.--index]="$index"
               >
                 @for(n of [0,1,2,3,4,5,6,7,8,9]; track n) {
                   <span class="h-[1em] leading-[1em] flex items-center justify-center">{{ n }}</span>
                 }
               </div>
            </div>
          } @else {
            <!-- Static Char -->
            <span>{{ item.char }}</span>
          }
        }
      </div>
    }
    
    @if(suffix() && suffix() !== '+') {
      <span>{{ suffix() }}</span>
    } @else {
      <!-- + debe estar en la parte superior del numero -->
      <span class="absolute -top-1 -right-8 text-5xl">{{ suffix() }}</span>
    }
  </span>
  <span class="md:text-base text-sm font-semibold text-center"
    [class.text-common-white]="!dark()" 
    [class.text-text-body]="dark()"
  >{{ description() }}</span>
</div>